import initialState from 'src/state'
import * as types from 'src/actions/types'

export default (state = initialState.currentUseCase, action) =>
  action.type === types.SET_CURRENT_USE_CASE ? action.payload : state
